import {Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild} from '@angular/core';
import {UserService} from '../../../user/services/user/user.service';
import {Notification} from '../../data/Notification';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {NotificationService} from '../../services/notification/notification.service';
import {NotificationListComponent} from '../notification-list/notification-list.component';

@Component({
  selector: 'notification-badge',
  templateUrl: './notification-badge.component.html',
  styleUrls: ['./notification-badge.component.scss'],
  animations: [
    trigger('openClose', [
      state('open', style({
        opacity: '1',
        // width: '*',
        // height: '*',
      })),
      state('closed', style({
        opacity: '0',
        // width: '0px',
        // height: '0px',
      })),
      transition('open => closed', [
        animate('0.5s')
      ]),
      transition('closed => open', [
        animate('0.5s')
      ]),
    ]),

  ]
})

export class NotificationBadgeComponent implements OnInit {
  @ViewChild(NotificationListComponent, {static: false})
  private notificationListComponent;

  @Output() onClose: EventEmitter<boolean> = new EventEmitter<boolean>();

  onDismiss: EventEmitter<boolean> = new EventEmitter<boolean>();
  notificationListOpen: boolean = true;

  get shouldShowDismiss() {
    return this.notificationService.notifications && this.notificationService.notifications.length > 0;
  }
  constructor(public userService: UserService,
              public notificationService: NotificationService) {
  }

  async ngOnInit(): Promise<void> {
  }

  async dismissAllNotifications(): Promise<void> {
    await this.notificationService.dismissAllNotifications().then(() => {
      // this.onDismiss.emit(true);
      this.notificationListComponent.dismissAllNotifications();
      this.notificationListOpen = false;
      setTimeout(() => {
        this.notificationListOpen = true;
      }, 500);
    });

    // this.closePopup();
  }

  closePopup(): void {
    this.onClose.emit(false);
  }
}
